<template>
  <!--<div class="user-main" :style="{minHeight:(screenHeight-85)+'px'}">-->
  <div class="user-main user-bg">
    <!--<section class="user-section">
      <div class="user__company">
        <h1 class="user__company-name">

          <span class="user__company-name--eng">{{companyInfo.shortEngName}}</span>
          <span class="user__company-name--chn">{{companyInfo.shortChnName}}</span>
        </h1>
        <div class="user__company-info" v-html="companyInfo.aboutCompany"></div>
      </div>-->
      <router-view></router-view>
    <!--</section>-->
  </div>
</template>
<script>

  import {mapGetters} from 'vuex'
  import * as types from '../vuex/types'

  export default {
    data () {
      return {
        screenHeight: document.body.clientHeight
      }
    },
    computed: {
      ...mapGetters({
        companyInfo: types.GET_COMPANY_INFO
      })
    }
  }
</script>
<style lang="scss">
  .user-main {
    overflow: hidden; // 不加会导致IE兼容问题
    width: 100%;
		position:relative;
    /*background: url("#{$imagePath}/user_bg.png") no-repeat;*/
   /*background:url(../assets/imgs/user_bg.png) no-repeat;*/
    background-size: cover;
        margin: 40px 0 0 0;
  }

	.user-main .user-main-bg{
		position:absolute;
		top:0;
		z-index:2;
		width:100%;
    height:100%;
		/*height:50%;
		background:red;*/
	    /*	background: -webkit-radial-gradient(center, ellipse cover, #2199e8 0%, #1c4ab5 100%);
    background: -webkit-radial-gradient(center ellipse, #2199e8 0%, #1c4ab5 100%);*/
    background: radial-gradient(ellipse at center, #bee5ff 0%,#1c4ab5 80%);
    opacity: 0.9;
    -webkit-animation: inset-shadow 4s ease-in forwards;
    animation: inset-shadow 4s ease-in forwards;
  }

  .user-main-bg{
    margin: 80px auto;
    background: !important #bee5;
       background-color: !important #bee5;
  }

	.user-main .user-main-bgpic{
		z-index: 1;
    /*background:url('https://www.opploans.com/assets/scenic-mountain-landscape-and-river-98762124328036c4459159ba734f92f04d3c418aab24dfffed623f330dee51b5.jpg');*/
   /* background:url(../assets/imgs/bg_rg.png) no-repeat;*/

    background-size: cover;
    background-position: center;
    position:absolute;
    width:100%;
    height:100%;
    /*height:50%;*/
	}


  .user-section {
    /*@include absolute-center;*/
    margin:120px auto;
    @include clear;
    width: $containerWidth;
  }

	.user-main .user-operation__login-bottom{
		height:100%;
	}

	.user-main .user-operation__login-submit{
		float: none;
    width: 80%;
    margin-left:auto;
    margin-right:auto;
    display: block;
    border: none;
    color: #fff;
    margin-top:30px;
    margin-bottom:30px;
    color: #fff;
    background-color: #498bd8;
    border-color: #3c83d5;
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.15), 0 1px 1px rgba(0,0,0,0.075);
	}

	.user-main .user-operation__login-submit:hover{
		background-color: #498bd7;
		border:none;
	}

  .user__company {
    float: left;
    width: 526px;

    & > *{
      font-family: 'FZLanTingHei_GBK';
      color:#fff;
      text-indent:35px;
      line-height: 36px;
	  text-indent:35px;
      line-height: 36px;
    }
  }

  .user__company-name {
    margin-bottom: 50px;
  }

  .user__company-name--eng {
    font-family: "Anders", "Arial";
    font-size: 36px;
    color: $white;
  }

  .user__company-name--chn {
    font-size: 28px;
    color: $orange;
    font-family: "FANGZHENGCUTANHEIJIANTI941", "Arial";
  }

  .user__company-info {
    & > div {
      padding: 0;
      color:#fff;
      font-size: 14px;
      line-height: 37px;
      font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
    }

    &:after {
      content: '';
      display: block;
      margin-top: 30px;
      width: 60px;
      height: 2px;
      background: $white;
    }
  }
</style>



// WEBPACK FOOTER //
// User.vue?8e2a821e